export default "__VITE_ASSET__D1K_XVQk__"